<template>
    <List v-model:selected="selected" class="v-list-chips" :items="option.options"
        :select-mode="option.selectMode || SelectMode.Single" :allow-unselect="option.allowUnselect || false"
        :compareFunc="(item: any) => item.value">
        <template #item="{ item }">

            <!--
            {{ labels?.[item] || item }}
             -->
            {{ item.label || item.value }}
        </template>
    </List>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { List, SelectMode } from 'gertrud';
import { ListRequestOptionsItem } from 'atlas-shared/dist/RequestOptions';

const props = defineProps<{

    option: ListRequestOptionsItem;
    labels?: Record<string, string>;
    modelValue: any;
}>();

const emit = defineEmits<{
    'update:modelValue': [value: any];
}>();

const selected = computed({
    get: () => props.option.options.find(o => o.value === props.modelValue),
    set: (val) => emit('update:modelValue', val?.value)
});
</script>